import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
 const navigate = useNavigate();

 return (
    <div className="min-h-screen bg-bgMain text-body p-6 md:p-12">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="mb-8 px-6 py-2.5 bg-white text-heading font-black rounded-xl hover:bg-bgSoft transition shadow-xl border border-accentGray/20 flex items-center gap-2 uppercase text-xs tracking-widest"
          title="Go back to previous page"
        >
          ← Back
        </button>

        <div className="bg-bgSection p-8 md:p-12 rounded-[40px] border border-accentGray/20 shadow-2xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -mr-32 -mt-32"></div>
          
          <h1 className="text-4xl font-black bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent mb-10 uppercase tracking-tighter relative z-10">Privacy Policy</h1>
          
          <div className="space-y-10 relative z-10">
            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">01</span>
                Information We Collect
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                We collect information that you provide directly to us, including your name, email address, phone number, and any other information you choose to provide when using our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">02</span>
                How We Use Your Information
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                We use the information we collect to provide, maintain, and improve our services, process transactions, send you technical notices and support messages, and communicate with you about products and services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">03</span>
                Information Sharing
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                We do not sell, trade, or rent your personal information to third parties. We may share your information only with trusted service providers who assist us in operating our website and conducting our business.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">04</span>
                Data Security
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">05</span>
                Cookies and Tracking
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">06</span>
                Your Rights
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                You have the right to access, update, or delete your personal information at any time. You can also opt-out of certain communications from us.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">07</span>
                Children's Privacy
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                Our service is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">08</span>
                Changes to This Policy
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-black text-heading mb-4 uppercase tracking-tight flex items-center gap-3">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm">09</span>
                Contact Us
              </h2>
              <p className="text-lg leading-relaxed text-body font-medium">
                If you have any questions about this Privacy Policy, please contact us at <span className="text-primary font-bold">connect@evolvexinnovations.org</span>
              </p>
            </section>

            <div className="pt-8 border-t border-accentGray/10">
              <p className="text-sm text-muted font-bold uppercase tracking-widest">
                Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;




